/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Pairing_Login_EmailInputs */

const cs_ebr_pairing_login_email = /** @type {(inputs: Ebr_Pairing_Login_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dle přihlašovacího e-mailu`)
};

const en_ebr_pairing_login_email = /** @type {(inputs: Ebr_Pairing_Login_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`by login e-mail`)
};

/**
* | output |
* | --- |
* | "by login e-mail" |
*
* @param {Ebr_Pairing_Login_EmailInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_pairing_login_email = /** @type {((inputs?: Ebr_Pairing_Login_EmailInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Pairing_Login_EmailInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_pairing_login_email(inputs)
	return cs_ebr_pairing_login_email(inputs)
});